import {
  ACTION_VALIDATE_TOKEN__REQUEST,
  ACTION_VALIDATE_TOKEN__SUCCESS,
  ACTION_VALIDATE_TOKEN__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_VALIDATE_TOKEN__REQUEST:
    case ACTION_VALIDATE_TOKEN__SUCCESS:
      return null;

    case ACTION_VALIDATE_TOKEN__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
